import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=5eabc1f5&scoped=true&"
import script from "./Spacer.vue?vue&type=script&lang=js&"
export * from "./Spacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eabc1f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eabc1f5')) {
      api.createRecord('5eabc1f5', component.options)
    } else {
      api.reload('5eabc1f5', component.options)
    }
    module.hot.accept("./Spacer.vue?vue&type=template&id=5eabc1f5&scoped=true&", function () {
      api.rerender('5eabc1f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/Spacer.vue"
export default component.exports